import $ from "jquery";
import { GameManager } from './managers/GameManager';
import WebFont from 'webfontloader';



export var EagleEyeExamInstance = function (gameType: string, gameElement: HTMLDivElement, gameLevelComplete: (score:number,gameName:string, pracPlay:string) => void, gameEndFunction: (score:number,gameName:string, pracPlay:string) => void, gameData: any, pracPlay: string, htpShow: boolean, titleShow: boolean, previousScore: number, customTimeLimit: number | null, assetUrl: string) {
    (<GameManager>GameManager.instance).startGameEagleEyeExam(gameType, <any>gameElement, gameLevelComplete, gameEndFunction, gameData, pracPlay, htpShow, titleShow, previousScore, customTimeLimit, assetUrl);

    document.title = "Eagle Eye Exam"

    WebFont.load({
        custom: {
            families: ['London Between', 'Exo Medium', 'Exo Bold', 'Proximanova Regular', 'Proximanova Black', 'Airbag Free'],
            urls: [(<GameManager>GameManager.instance).assetUrl + '/assets/eyeexam/stylesheets/fonts.css']
        }
    });

    return {
        destroy: function () {
            (<GameManager>GameManager.instance).destroyGame();
        },
        restart: function () {
            (<GameManager>GameManager.instance).restartGame();
        }
    }
}



// Start Mock Initialization
var OnGameLevelComplete = function (score: number, gameName: string, puzzleName: string) {
    console.log("Game Level Complete External Call!");
    console.log(`Score: ${score} Game Name: ${gameName} Puzzle Name: ${puzzleName}`);
}

var OnGameEnd = function (score: number, gameName: string) {
    console.log("Game End External Call!");
    console.log(`Score: ${score} Game Name: ${gameName}`);
}

// var mock_json_file = {
//   questions: [
//       {
//           id: "eagleeyeexam-puzzle-1",
//           firstImageSource: "assets/eyeexam/ui/Placeholder Images/image_01a.png",
//           secondImageSource: "assets/eyeexam/ui/Placeholder Images/image_01b.png",
//           answerX1: 361,
//           answerY1: 9,
//           answerX2: 399,
//           answerY2: 78,
//       },
//       {
//         id: "eagleeyeexam-puzzle-2",
//         firstImageSource: "assets/eyeexam/ui/Placeholder Images/image_02a.png",
//         secondImageSource: "assets/eyeexam/ui/Placeholder Images/image_02b.png",
//         answerX1: 200,
//         answerY1: 23,
//         answerX2: 386,
//         answerY2: 147,
//       },
//       {
//         id: "eagleeyeexam-puzzle-3",
//         firstImageSource: "assets/eyeexam/ui/Placeholder Images/image_03a.png",
//         secondImageSource: "assets/eyeexam/ui/Placeholder Images/image_03b.png",
//         answerX1: 200,
//         answerY1: 0,
//         answerX2: 266,
//         answerY2: 166,
//       },
//       {
//         id: "eagleeyeexam-puzzle-4",
//         firstImageSource: "assets/eyeexam/ui/Placeholder Images/image_04a.png",
//         secondImageSource: "assets/eyeexam/ui/Placeholder Images/image_04b.png",
//         answerX1: 18,
//         answerY1: 125,
//         answerX2: 393,
//         answerY2: 154,
//       },
//       {
//         id: "eagleeyeexam-puzzle-5",
//         firstImageSource: "assets/eyeexam/ui/Placeholder Images/image_05a.png",
//         secondImageSource: "assets/eyeexam/ui/Placeholder Images/image_05b.png",
//         answerX1: 293,
//         answerY1: 22,
//         answerX2: 400,
//         answerY2: 140,
//       },
//   ]
// };

var rawGameData = {
    questions: [
        {
            "id": "13316416",
            "type": "game_eye_exam",
            "first_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_01a_0.png",
            "second_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_01b_0.png",
            "answer_x1": 363,
            "answer_y1": 8,
            "answer_x2": 400,
            "answer_y2": 84
        },
        {
            "id": "13316421",
            "type": "game_eye_exam",
            "first_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_02a_0.png",
            "second_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_02b_0.png",
            "answer_x1": 194,
            "answer_y1": 21,
            "answer_x2": 392,
            "answer_y2": 149
        },
        {
            "id": "13316426",
            "type": "game_eye_exam",
            "first_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_03a_0.png",
            "second_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_03b_0.png",
            "answer_x1": 179,
            "answer_y1": 0,
            "answer_x2": 274,
            "answer_y2": 181
        },
        {
            "id": "13316431",
            "type": "game_eye_exam",
            "first_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_04a_0.png",
            "second_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_04b_0.png",
            "answer_x1": 17,
            "answer_y1": 123,
            "answer_x2": 394,
            "answer_y2": 161
        },
        {
            "id": "13316436",
            "type": "game_eye_exam",
            "first_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_05a_0.png",
            "second_image_source": "http:\/\/us-en.superbook.cbn.com\/sites\/default\/files\/image_05b_0.png",
            "answer_x1": 288,
            "answer_y1": 19,
            "answer_x2": 400,
            "answer_y2": 140
        }
    ]
};

var _gameData = {
    questions: [
        {
            id: "13316416",
            type: "game_eye_exam",
            firstImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_01a_0.png",
            secondImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_01b_0.png",
            answerX1: 363,
            answerY1: 8,
            answerX2: 400,
            answerY2: 84
        },
        {
            id: "13316421",
            type: "game_eye_exam",
            firstImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_02a_0.png",
            secondImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_02b_0.png",
            answerX1: 194,
            answerY1: 21,
            answerX2: 392,
            answerY2: 149
        },
        {
            id: "13316426",
            type: "game_eye_exam",
            firstImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_03a_0.png",
            secondImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_03b_0.png",
            answerX1: 179,
            answerY1: 0,
            answerX2: 274,
            answerY2: 181
        },
        {
            id: "13316431",
            type: "game_eye_exam",
            firstImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_04a_0.png",
            secondImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_04b_0.png",
            answerX1: 17,
            answerY1: 123,
            answerX2: 394,
            answerY2: 161
        },
        {
            id: "13316436",
            type: "game_eye_exam",
            firstImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_05a_0.png",
            secondImageSource: "http://us-en.superbook.cbn.com/sites/default/files/image_05b_0.png",
            answerX1: 288,
            answerY1: 19,
            answerX2: 400,
            answerY2: 140
        }
    ]
};



// End Mock Initialization